import { DownloadOutlined, UploadOutlined } from '@ant-design/icons';
import { Space, Button, Row, Col } from 'antd';
import { MetadataLogic } from 'common/schema/metadata/MetadataLogic';
import { IWidget } from 'common/schema/widget/Widget';
import React from 'react';
import { WidgetInputFormItem } from '../../view/wrapper/WidgetInputFormItem';
import { WidgetUploadInput } from '../upload/WidgetUploadInput';
import { WidgetPreviewDownloader } from './WidgetPreviewDownloader';
import './CompactSignedInput.scss';

export interface ICompactSignedInputProps {
  widget: IWidget;
  name: string;
}

export function CompactSignedInput(props: ICompactSignedInputProps) {
  const { widget, name } = props;

  const metadata = MetadataLogic.singleFromWidget(widget);
  const documentId = widget.input!.extra?.documentId;

  return (
    <WidgetInputFormItem
      name={name}
      input={widget.input!}
      className="compact-signed-input"
    >
      <Row gutter={12}>
        <Col span={12}>
          <WidgetPreviewDownloader
            buttonText={widget.input?.extra?.downloadButton}
            procedureId={widget.procedureId}
            documentId={documentId}
            icon={<DownloadOutlined />}
            size="middle"
            type="default"
            ghost={false}
            block
            style={{ marginBottom: '12px' }}
          />
        </Col>
        <Col span={12}>
          <WidgetUploadInput
            metadata={metadata}
            name={name}
            options={widget.input?.validation}
            description={widget.input?.extra?.uploadDescription}
            procedureId={widget.procedureId}
            widgetType={widget.input?.type}
            component={
              <Button icon={<UploadOutlined />} block type="primary">
                {widget.input?.extra?.uploadDescription ?? 'Carica Documento'}
              </Button>
            }
          />
        </Col>
      </Row>
    </WidgetInputFormItem>
  );
}
